import React, { useEffect, useState } from "react";
import Button from "../commons/Button";
import { Link, useNavigate } from "react-router-dom";
import { addToCart } from "../../firebase/listings";
import { useAuth } from "../../context/authContext";
import { toast } from "react-toastify";
import { useAtom } from "jotai";
import { userAtom } from "../../store";
import DialogSuccess from "../dialogs/DialogSuccess copy";
import { getCategoryById } from "../../firebase/categories";

const CardItem = ({
  card,
  cardClassName = "",
  imageClassName = "",
  titleClassName = "",
  priceClassName = "",
  descriptionClassName = "",
  buttonClassName = ""
}) => {
  const [userData, setUserData] = useAtom(userAtom)
  const navigate = useNavigate()
  const [category, setCategory] = useState(null)

  useEffect(() => {
    if (card) {
      getCategoryById((card.category)).then((data) => {
        setCategory(data)
      })
    }
  }, [card])

  const handleViewDetail = () => {
    // Buying only needs an account, not a membership -- a membership is a
    // seller's obligation. Signed out still goes to register, since checkout
    // is account-only all the way through.
    const detailPath = card?.source === 'shopify' ? `/shopify/${card.id}` : `/marketplace/${card.id}`

    if (!userData) {
      navigate('/register')
    } else {
      navigate(detailPath)
    }
  }

  return (
    <div
      className={`p-3 flex flex-col card-item w-full bg-white/5 backdrop-blur-sm h-full ${cardClassName}`}
    >
      <div className="relative">
        <div className="relative w-full !pt-[90%]">
          <img
            src={card.pictures[0] || "/assets/images/image_item_default.png"}
            alt={card.title}
            className={`!absolute top-0 h-full object-cover w-full bg-white ${imageClassName}`}
          />
        </div>
      </div>

      <div className="mt-3 flex flex-col justify-between h-full gap-4">
        <div>
          <div className="flex !h-fit justify-between items-center gap-2">
            <span
              className={`text-lg max-sm:text-sm text-primary uppercase font-aeonik font-bold text-nowrap ${priceClassName}`}
            >
              {
                typeof card.price === 'number' ?
                  '$' + card.price.toFixed(2) : card.price
              }
            </span>

            <div className="max-sm:hidden uppercase text-[8px]">
              {
                category &&
                <span className="mr-1 text-white border-white border-[1px] px-[6px] py-1 rounded-[12px] bg-[#CACACA20]">
                  {
                    category.name
                  }
                </span>
              }

              <span className=" border-primary text-primary border-[1px] px-[6px] py-1 rounded-[12px] bg-[#1AB6F920]">
                {
                  card.rarity
                }
              </span>
            </div>
          </div>

          <p
            className={`text-lg uppercase mt-1 text-white line-clamp-1 leading-[1.4] max-sm:text-sm ${titleClassName}`}
          >
            {card.title}
          </p>

          <p
            className={`text-white/60 text-sm max-sm:hidden mt-1 font-light line-clamp-3 ${descriptionClassName}`}
          >
            {card.description}
          </p>
        </div>

        <div className="sm:hidden uppercase text-[8px]">
          {
            category &&
            <span className="mr-1 text-white border-white border-[1px] px-[6px] py-1 rounded-[12px] bg-[#CACACA20]">
              {
                category.name
              }
            </span>
          }

          <span className=" border-primary text-primary border-[1px] px-[6px] py-1 rounded-[12px] bg-[#1AB6F920]">
            {
              card.rarity
            }
          </span>
        </div>

        {/* Button renders its own <button>; wrapping it in another one was
            invalid markup that only worked because the click bubbled. */}
        <Button
          onClick={handleViewDetail}
          divClassName={`bg-primary sm:text-base text-xs  ${buttonClassName}`}
          buttonClassName="group-hover:!bg-white group-hover:!bg-none group-hover:text-black sm:!p-3 !p-[10px]"
        >
          <div className="flex items-center">
            <span className="mr-1">
              {card?.buttonText || 'View Details'}
            </span>

            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" className="mt-[1px]">
              <path d="M0.708333 8L0 7.29167L3.29167 4L0 0.708333L0.708333 0L4.70833 4L0.708333 8Z" className="fill-white group-hover:fill-black" />
            </svg>
          </div>
        </Button>
      </div>
    </div>
  )
};

export default CardItem;
